<p class="text-base font-semibold leading-8 text-openflis-600">404</p>
<h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
    Page not found
</h1>
<p class="mt-6 text-base leading-7 text-gray-600">
    Sorry, we couldn't find the page you're looking for.
</p>
